import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import Logo from '../../images/Logo.png';
import BackgroundImg from '../../images/login_bg.png';

const AuthFormContainer = ({ children, }) => {
  const classes = useStyles();
  return (
    <div className={classes.mainbg}>
      <div className={classes.formContainer}>
        <img src={Logo} className={classes.logo} alt="logo" />
        {children}
      </div>
    </div>
  );
};

AuthFormContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
};

const useStyles = createUseStyles({
  mainbg: {
    paddingTop: '2em',
    height: '100vh',
    background: 'white',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${BackgroundImg})`,
    backgroundPosition: 'bottom',
  },
  formContainer: {
    maxWidth: '360px',
    margin: '80px auto',
    textAlign: 'center',
  },
  logo: {
    width: '150px',
  },

});

export default AuthFormContainer;
